import "./Resources.css";
import Footer from "components/Footer/Footer";
import ScrollToTop from "components/ScrollToTop";
const Resources2 = () => {
  return (
    <section className='resourcesSection'>
      <div className='resources2'>
        <figure className='snip0056'>
          <div className='resourcesBar'></div>
          <div className='resourcesBar2'></div>
          <figcaption>
            <h2>
              <span>1st Year </span>Resources
            </h2>

            <p>From books to notes to previous year papers, all things acads for 1st year.</p>
          </figcaption>
          <img src='/assets/images/1st-year.jpg' alt='sample8' />
          <div className='position'>
            <a href='https://drive.google.com/drive/folders/1cZjU_l2NUIuxnRofN30DqavQZ1tHr4Wy' target='_blank'>
              View More
            </a>
          </div>
        </figure>
        <figure className='snip0056'>
          <div className='resourcesBar'></div>
          <div className='resourcesBar2'></div>
          <figcaption>
            <h2>
              <span>2nd Year</span> Resources
            </h2>
            <p>Branch wise study material for 2nd year.</p>
          </figcaption>
          <img src='/assets/images/2nd-year.jpg' alt='sample9' />
          <div className='position'>
            <a href='/2nd_year_material' target='_blank'>
              View More
            </a>
          </div>
        </figure>
        <figure className='snip0056'>
          <div className='resourcesBar'></div>
          <div className='resourcesBar2'></div>
          <figcaption>
            <h2>
              <span>Academic</span> Information
            </h2>
            <p>All important information about scholarships and more for students.</p>
          </figcaption>
          <img src='/assets/images/academic.jpg' alt='sample8' />
          <div className='position'>
            <a href='http://iitkgp.ac.in/for-students' target='_blank'>
              View More
            </a>
          </div>
        </figure>
        <figure className='snip0056'>
          <div className='resourcesBar'></div>
          <div className='resourcesBar2'></div>
          <figcaption>
            <h2>
              <span>Fundae</span> Docs
            </h2>
            <p>All the tools to crack problems you will face in KGP.</p>
          </figcaption>
          <img src='/assets/images/fundae.jpg' alt='sample9' />
          <div className='position'>
            <a
              href='https://drive.google.com/drive/folders/1kHOCcFcWkncHaAPZtzOCHUDn4aKQ84KV?usp=sharing'
              target='_blank'>
              View More
            </a>
          </div>
        </figure>
        <figure className='snip0056'>
          <div className='resourcesBar'></div>
          <div className='resourcesBar2'></div>
          <figcaption>
            <h2>
              <span>GMAT</span> Resources
            </h2>
            <p>Guide to Applying for Overseas Education</p>
          </figcaption>
          <img src='/assets/images/gmat.png' alt='sample10' />
          <div className='position'>
            <a href='https://drive.google.com/drive/folders/1YZnPLwAwuY8cEg9-HnVdvmku6VJnDCdl' target='_blank'>
              View More
            </a>
          </div>
        </figure>
      </div>
      <Footer />
      <ScrollToTop />
    </section>
  );
};

export default Resources2;
